import { module } from 'angular';
import templateBuilderEmailValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/email/validate.html', templateBuilderEmailValidate);
});
